//  定点 巡检记录
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  PictureOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
  DeleteOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { theme, Card, Tag, Table, message, Pagination, Select, Input, Space, DatePicker } from 'antd';
import { getPatrolImages, delRecordApi } from '@/server/risk'
import { basicPath } from '@/router/config';//引入路由基础路径
import locale from 'antd/es/date-picker/locale/zh_CN';
import dayjs from 'dayjs'

function RecordLeak (props) {
  const { getInfo } = props
  const { RangePicker } = DatePicker;
  const location = useLocation();
  const params = location.state;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();//路由跳转
  const token = localStorage.getItem('dock_token');
  const companyId = localStorage.getItem('dock_CompanyID');
  const {
    token: { colorText, colorPrimary },
  } = theme.useToken(); //获取主题颜色
  const [AirportPermissionsArrName, setAirportPermissionsArrName] = useState([])//权限列表
  const [searchList, setSearchList] = useState({
    access_token: token,
    status: '',
    urlType: 1,
    type: 2,
    order: '',
    title: '',//航线名称
    executetype: undefined,//巡检记录类型
    s_start_time: undefined,//开始-开始时间
    s_end_time: undefined,//开始-结束时间
    e_start_time: undefined,//结束-开始时间
    e_end_time: undefined,//结束-结束时间

    page: 1,
    perpage: 10,
    total: 0,
  });//搜索的数据
  const [dataList, setDataList] = useState([])//获取到的数据
  const [typeDictionary, setTypeDictionary] = useState([])//类型字典

  // 获取记录
  const getData = async (list) => {
    setLoading(true)
    let obj = {
      access_token: token,
      type: list.urlType,
      title: list.title,
      executetype: list.executetype,
      s_start_time: list.s_start_time,
      s_end_time: list.s_end_time,
      e_start_time: list.e_start_time,
      e_end_time: list.e_end_time,
      page: list.page,
      perpage: list.perpage,
    }
    let res = await getPatrolImages(obj)
    let sea = searchList
    if (res.ret === 200) {
      sea.page = res.data.page
      sea.perpage = res.data.perpage
      sea.total = res.data.total
      setDataList(res.data.items)
      setSearchList({ ...sea })

      setTypeDictionary([...res.data.sjzd?.executetype])
    } else {
      message.warning(res.msg || `服务器开了小差，请重试`);
    }
    setLoading(false)
  }
  //图片查看页
  const PictureViewPage = (item) => {
    const transfer = {
      statid: item.id || item.statid,
      insIds: Number(item.InsIDs),
      title: item.routes_name,
      start_time: item.start_time,
      end_time: item.endtime,
      companyId: companyId,
      search: searchList
    }
    navigate('/routine_record_info', { state: transfer })
  }

  const delRecordList = async (id) => {
    let res = await delRecordApi({ access_token: localStorage.getItem('dock_token') || '', id: id })
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    let sea = searchList
    if (searchList.total > 10 && searchList.total % 2 === 1 && searchList.page > 1) {
      sea.page = sea.page - 1
      setSearch({ ...sea })
    }
    message.success('删除成功');
    getData(sea);
  }

  //表头配置
  const columns = [
    {
      title: '类型',
      dataIndex: 'executetype',
      render: (text, record) => {
        switch (text) {
          case 1:
            return (<div>常规</div>)
          case 2:
            return (<div>临时</div>)
          case 3:
            return (<div>指令</div>)
          default:
            return (<div>暂无类型</div>)
        }
      },
    },
    {
      title: '航线名称', dataIndex: 'routes_name',
    },
    // {
    //   title: '机场', dataIndex: 'dock_id',
    // },
    {
      title: '巡检开始时间',
      dataIndex: 'start_time',
      render: (_, item, index) => {
        return (
          <div>
            {
              item.start_time ?
                <div>
                  <span className='fSize14 opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
                  <span className='fSize14 opacity0_45'>{item.start_time.split(' ')[1]}</span>
                </div>
                : <div style={{ color: 'rgba(255,255,255,0.25)' }}>-</div>
            }
          </div>
        );
      },
    },
    {
      title: '巡检结束时间',
      dataIndex: 'endtime',
      render: (_, item, index) => {
        return (
          <div>
            {
              item.endtime
                ?
                <div>
                  <span className='fSize14 opacity0_85 margR8'>{item.endtime.split(' ')[0]}</span>
                  <span className='fSize14 opacity0_45'>{item.endtime.split(' ')[1]}</span>
                </div>
                : <div style={{ color: 'rgba(255,255,255,0.25)' }}>-</div>
            }
          </div>
        );
      },
    },
    {
      title: '图像',
      dataIndex: 'pic_count',
      render: (text, record) => {
        return (
          text
            ?
            <div className='flex pointer'
              onClick={() => { PictureViewPage(record) }}
            >
              <span className='pdR8' style={{ color: '#177DDC' }} >{text}</span>
              <PictureOutlined style={{ color: '#177DDC' }} />
            </div>
            : <span className='opa25'>-</span>
        )
      },
    },
    {
      title: '状态',
      dataIndex: 'ins_status',
      render: (text, record) => {
        return (
          <div className='flex'>
            <div>
              <Tag style={{ display: text === 2 ? `block` : `none` }}
                icon={<SyncOutlined spin />} color="processing">
                执行中
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 1 || text === 3 ? `block` : `none` }}
                icon={<CheckCircleOutlined />} color="success">
                完成
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 5 ? `block` : `none` }}
                icon={<CloseCircleOutlined />} color="error">
                失败
              </Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: '说明',
      render: (_, item, index) => {
        return (
          <div>
            {item.remark ? <span>{item.remark}</span> : <span className='opa25'>-</span>}
          </div>
        )
      },
    },
    {
      title: '操作',
      render: (text, record) => {
        return (
          <>
            {
              AirportPermissionsArrName.indexOf(`InsImageList_Del_${searchList.urlType}`) > -1
                ? (
                  <span
                    className='pointer'
                    style={{ color: '#3C89E8' }}
                    onClick={() => { delRecordList(record.id) }}
                  >
                    删除
                  </span>
                )
                : (<span className='opa25'>-</span>)
            }
          </>
        );
      },
    },
  ];

  useEffect(() => {//监听路由  获取相应的urlType
    setAirportPermissionsArrName([...JSON.parse(localStorage.getItem('dock_AirportPermissionsArrName'))])
    let sea = searchList
    sea.title = ''
    sea.executetype = undefined//巡检记录类型
    sea.s_start_time = undefined//开始-开始时间
    sea.s_end_time = undefined//开始-结束时间
    sea.e_start_time = undefined//结束-开始时间
    sea.e_end_time = undefined//结束-结束时间
    switch (location.pathname) {
      case '/fixedPoint_record_electricTower'://管道
        sea.urlType = 8;
        sea.type = 1;
        break;
      case '/fixedPoint_record_station'://电网
        sea.urlType = 9;
        sea.type = 1;
        break;
      default:
        break;
    }

    if (params) {
      setSearchList({ ...params.search });
      getData({ ...params.search });
    } else {
      getData(sea);
    }
    setSearchList({ ...sea });

    //eslint-disable-next-line
  }, [location.pathname, params])

  return (
    <Card style={{ border: 0 }} className="mar24">
      <>{/* 头部 */}
        <div className='flex jcsb align_center marB24 wid100'>
          <div>

          </div>

          <Space>
            <>{/* 类型 */}
              <Select
                allowClear
                className='wid100'
                placeholder='类型'
                options={typeDictionary}
                value={searchList.executetype}
                onChange={(e) => {
                  let sea = searchList
                  sea.executetype = e
                  sea.page = 1
                  setSearchList({ ...sea })
                  getData(sea)
                }}
              />
            </>

            <>{/* 航线名称 */}
              <Input
                allowClear
                placeholder='航线名称'
                id='Input_LineNameInput'
                value={searchList.title}
                onChange={(e) => {
                  let sea = searchList
                  sea.title = e.target.value
                  setSearchList({ ...sea })
                }}
                onPressEnter={() => { document.getElementById('Input_LineNameInput').blur() }}
                onBlur={(e) => {
                  let sea = searchList
                  sea.title = e.target.value
                  sea.page = 1
                  setSearchList({ ...sea })
                  getData(sea)
                }}
              />
            </>

            <RangePicker //巡检开始起止
              locale={locale}
              className='none'
              showHour
              clearFilters
              value={searchList.s_start_time ? [dayjs(searchList.s_start_time, 'YYYY-MM-DD'), dayjs(searchList.s_end_time, 'YYYY-MM-DD')] : null}
              format="YYYY-MM-DD"
              placeholder={['巡检开始起', '巡检开始止']}
              onChange={(e) => {
                let sea = searchList
                if (e) {
                  sea.s_start_time = dayjs(e[0]).format('YYYY-MM-DD')
                  sea.s_end_time = dayjs(e[1]).format('YYYY-MM-DD')
                } else {
                  sea.s_start_time = ''
                  sea.s_end_time = ''
                }
                sea.page = 1
                setSearchList({ ...sea })
                getData(sea)
              }}
            />

            <RangePicker //巡检结束起止
              locale={locale}
              className='none'
              showHour
              clearFilters
              value={searchList.e_start_time ? [dayjs(searchList.e_start_time, 'YYYY-MM-DD'), dayjs(searchList.e_end_time, 'YYYY-MM-DD')] : null}
              format="YYYY-MM-DD"
              placeholder={['巡检结束起', '巡检结束止']}
              onChange={(e) => {
                let sea = searchList
                if (e) {
                  sea.e_start_time = dayjs(e[0]).format('YYYY-MM-DD')
                  sea.e_end_time = dayjs(e[1]).format('YYYY-MM-DD')
                } else {
                  sea.e_start_time = ''
                  sea.e_end_time = ''
                }
                sea.page = 1
                setSearchList({ ...sea })
                getData(sea)
              }}
            />
          </Space>
        </div>

      </>

      <>{/* table */}
        <Table
          columns={columns}
          dataSource={dataList}
          pagination={false}
          loading={loading}
          rowKey='id'
          onChange={(newPagination, filters, sorter) => {
            let sea = searchList
            sea.current = newPagination.current;
            sea.pageSize = newPagination.pageSize;
            setSearchList({ ...sea })
            getData(sea) //加载列表
          }}
        />

        <Pagination
          className='flex jcr pdT16'
          align='end'
          current={searchList.page}
          pageSize={searchList.perpage}
          total={searchList.total}
          showTotal={total => `共 ${total} 条数据`}
          onChange={
            (current, pageSize) => { //选择当前页后执行
              let sea = { ...searchList };
              sea.perpage = pageSize;
              sea.page = current;
              setSearchList({ ...sea });
              getData(sea);
            }
          }
        />

      </>
    </Card >
  )
}
export default RecordLeak